export enum OperationType {
    None = 0,
    Add = 1,
    Edit = 2,
    Delete = 3,
}